import { render, staticRenderFns } from "./OrariProvimeve.vue?vue&type=template&id=b8a2d1c6"
import script from "./OrariProvimeve.vue?vue&type=script&lang=js"
export * from "./OrariProvimeve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports